import { render } from "./SocialImage.vue?vue&type=template&id=8ccceb04"
import script from "./SocialImage.vue?vue&type=script&lang=js"
export * from "./SocialImage.vue?vue&type=script&lang=js"

import "./SocialImage.vue?vue&type=style&index=0&id=8ccceb04&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__